import { cashbackApi } from '../../api'
import { CASHBACK_COMPANY_DB } from '../../config'
import { DEMO_DATABASE, DEFAULT_PAGE_SIZE } from './constants'

const asArray = (res) => (Array.isArray(res?.data) ? res.data : [])

export const cleanParams = (params = {}) =>
	Object.entries(params).reduce((acc, [key, value]) => {
		if (value === undefined || value === null || value === '') return acc
		acc[key] = value
		return acc
	}, {})

const withDatabase = (params) =>
	DEMO_DATABASE ? { ...params, database: DEMO_DATABASE } : params

const get = (url, params = {}, config = {}) =>
	cashbackApi
		.get(url, { params: withDatabase(cleanParams(params)), ...config })
		.then(asArray)

/* ================= Invoices ================= */

export const getInvoices = (params, config) => get('invoices', params, config)

export const getInvoiceByDocEntry = (docEntry, config) =>
	get('invoices', { docEntry }, config).then((list) => list[0] || null)

export const getInstallments = (docEntry, config) =>
	get('invoices/installments', { docEntry, pageSize: 50 }, config)

export const getPayments = (docEntry, config) =>
	get('invoices/payments', { docEntry, pageSize: 100 }, config)

export const createInvoice = (body) =>
	cashbackApi.post('invoices', body).then((res) => res.data)

/* ================= Spravochniklar ================= */

export const getBusinessPartners = (params, config) =>
	get('business-partners', { pageSize: DEFAULT_PAGE_SIZE, ...params }, config)

export const getSalesEmployees = (params, config) =>
	get('sales-employees', { pageSize: DEFAULT_PAGE_SIZE, ...params }, config)

export const getWarehouses = (params, config) =>
	get('warehouses', { pageSize: 200, ...params }, config)

export const getSerialNumbers = (params, config) =>
	get('items/serial-numbers', { pageSize: DEFAULT_PAGE_SIZE, ...params }, config)

export const getItems = ({ search, ...params } = {}, config) => {
	const base = { pageSize: DEFAULT_PAGE_SIZE, availableOnly: 'Y', ...params }
	if (!search) return get('items', base, config)
	return get('items', { ...base, search }, config).catch((err) => {
		if (err?.response?.status === 401 || config?.signal?.aborted) throw err
		return get('items', { ...base, itemName: search }, config)
	})
}

/* ================= Kesh-bek (eskisidagi «Кэшбэк по продаже» bloki) ================= */

// Leder javobi massiv emas — { items: [...] } ko'rinishida keladi
export const getCashbackLedger = (params, config) =>
	cashbackApi
		.get('ledger', { params: cleanParams(params), ...config })
		.then((res) => res?.data?.items || [])

// Sverka: shu hujjat bo'yicha SAP dagi ichki hisob-kitob qatorlari
export const getReconciliations = (params, config) =>
	cashbackApi
		.get('reconciliations', {
			params: cleanParams({ companyDb: CASHBACK_COMPANY_DB, ...params }),
			...config,
		})
		.then(asArray)

// Ro'yxat faqat hujjatning o'z qatorini beradi — ikkinchi tomoni shu reconNum ichida
export const getReconciliationLines = (reconNum, config) =>
	cashbackApi
		.get(`reconciliations/${reconNum}`, {
			params: { companyDb: CASHBACK_COMPANY_DB },
			...config,
		})
		.then((res) => {
			const body = res?.data
			return Array.isArray(body) ? body : body?.rows || []
		})

// Mijoz kartochkasidan telefon (ro'yxatda bo'lmasa kesh-bek shu yerdan qidiriladi)
export const getBusinessPartnerPhone = (cardCode, config) =>
	get('business-partners', { cardCode }, config).then(
		(list) => list[0]?.phone || list[0]?.U_TelephoneRaw || '',
	)
